import React, { createContext, useContext, useState, useEffect } from "react";
import glpiService from "../api/GLPIService";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [sessionToken, setSessionToken] = useState(localStorage.getItem("glpiToken"));
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);
    const [additionalData, setAdditionalData] = useState({
      profiles: [],
      activeEntity: null,
      activeProfile: null,
    });
  
    const validateToken = async () => {
      try {
        if (sessionToken) {
          const sessionData = await glpiService.getFullSession(sessionToken);
          processSessionData(sessionData);
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error("Token inválido:", error);
        logout();
      } finally {
        setLoading(false);
      }
    };
    
    const processSessionData = async (sessionData) => {
        const { session } = sessionData;
                console.log(session.glpiactiveentities);
        // Obtener estados y prioridades      
        setUser({
          id: session.glpiID,
          fullName: session.glpifriendlyname,
        });
  
      setAdditionalData({
        profiles: session.glpiprofiles
          ? Object.entries(session.glpiprofiles).map(([id, profile]) => ({
              id,
              name: profile.name,
            }))
          : [],
        activeProfile: session.glpiactiveprofile,
      });
    };
  
    useEffect(() => {
      validateToken();
    }, []);
  
    const login = async (username, password) => {
      try {
        setLoading(true);
        const response = await glpiService.initSession(username, password);
        const sessionData = await glpiService.getFullSession(response.session_token);
        setLoading(false);
        processSessionData(sessionData);
        setSessionToken(response.session_token);
        setIsAuthenticated(true);
        localStorage.setItem("glpiToken", response.session_token);
      } catch (error) {
        console.error("Error en el login:", error);
        setLoading(false);
        setIsAuthenticated(false);
        throw error;
      }
    };
  
    const logout = () => {
      setUser(null);
      setSessionToken(null);
      setIsAuthenticated(false);
      setAdditionalData({
        profiles: [],
        activeEntity: null,
        activeProfile: null,
      });
      localStorage.removeItem("glpiToken");
    };
  
    return (
      <AuthContext.Provider
        value={{
          user,
          sessionToken,
          isAuthenticated,
          loading,
          additionalData,
          login,
          logout,
        }}
      >
        {children}
      </AuthContext.Provider>
    );
  };
  
export const useAuth = () => useContext(AuthContext);
